export default {"src":"/_next/static/media/user_gradient.32bfe6c1.svg","height":31,"width":27,"blurWidth":0,"blurHeight":0};